export const LeftPaginateIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.83333 11.3332L4.5 7.99984L7.83333 4.6665M12.5 11.3332L9.16667 7.99984L12.5 4.6665"
        stroke="#150823"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};
